import { organizationSectionEntityName, } from '../../../../backend/config/classifiers/OrganizationSectionClassifier/shared';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useAnonymousClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useOrganizationSections() {
    const context = React.useContext(ContactManagementConfigContext);
    const anonymousClient = useAnonymousClient(context.appName, organizationSectionEntityName);
    const [isLoading, setIsLoading] = React.useState(true);
    const [sections, setSections] = React.useState();
    React.useEffect(() => {
        anonymousClient
            .storageList({
            filter: [{ column: 'status', op: '=', value: 'active' }],
            orderBy: [{ column: 'displayOrder' }, { column: 'name' }],
        })
            .then((response) => setSections(response.rows))
            .catch((error) => {
            handleErrorSnackbar(error);
            setSections([]);
        })
            .finally(() => {
            setIsLoading(false);
        });
    }, [anonymousClient]);
    return { sections, isLoading };
}
